<!-- Contenedor principal -->
<div class="w-full max-w-5xl mx-auto">
    <div class="rounded-xl bg-[#1f46ea] text-white shadow-xl p-6 relative overflow-hidden">
      <h1 class="text-4xl md:text-5xl font-extrabold">Devolver pasajes</h1>
      <p class="opacity-90">Para devolver un pasaje, completá el formulario con los datos del pasajero y presioná buscar.</p>
  
      <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-3">
  
        <!-- fila 1 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Tipo Documento</mat-label>
            <mat-select formControlName="docType">
              <mat-option *ngFor="let t of docTypes" [value]="t.value">{{ t.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isInvalid('docType')">Elegí un tipo de documento.</mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Número de documento</mat-label>
            <input matInput formControlName="docNumber" inputmode="numeric" placeholder="Número de documento" />
            <mat-error *ngIf="isInvalid('docNumber')">
              Ingresá un número válido (6–12 dígitos).
            </mat-error>
          </mat-form-field>
        </div>
  
        <!-- fila 2 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Fecha viaje</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="travelDate" placeholder="dd/mm/aaaa" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="isInvalid('travelDate')">Elegí la fecha del viaje.</mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>E-mail del pasajero</mat-label>
            <input matInput type="email" formControlName="email" placeholder="E-mail" />
            <mat-error *ngIf="isInvalid('email')">Ingresá un e-mail válido.</mat-error>
          </mat-form-field>
        </div>
  
        <!-- fila 3 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Número de boleto</mat-label>
            <input matInput formControlName="ticketNumber" placeholder="Número de boleto" />
          </mat-form-field>
  
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Código de devolución</mat-label>
            <input matInput formControlName="refundCode" placeholder="Código de devolución" />
          </mat-form-field>
        </div>
  
        <!-- ayuda -->
        <div class="text-sm opacity-90 -mt-2">
          <a class="underline hover:no-underline cursor-pointer"
             matTooltip="Encontrás el número de boleto y el código de devolución en el e-mail de confirmación y en el PDF del pasaje.">
            ¿Dónde encuentro estos códigos?
          </a>
        </div>
  
        <!-- reCAPTCHA -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <re-captcha
              [siteKey]="recaptchaSiteKey"
              theme="dark"
              (resolved)="onRecaptchaResolved($event)"
              (error)="onRecaptchaError()">
            </re-captcha>
            
            <!-- Error del reCAPTCHA -->
            <div *ngIf="recaptchaError()" class="text-red-200 text-sm mt-2">
              {{ recaptchaError() }}
            </div>
          </div>
  
          <div class="md:justify-self-end">
            <button mat-raised-button color="primary"
                    class="bg-green-600 hover:bg-green-700 text-white font-semibold px-10 py-2 rounded-xl disabled:cursor-not-allowed w-full"
                    [disabled]="form.invalid || loading() || !recaptchaToken()"
                    type="submit">
              <span *ngIf="!loading()">Buscar pasaje</span>
              <span *ngIf="loading()" class="flex items-center gap-2">
                <mat-icon class="animate-spin">refresh</mat-icon>
                Procesando...
              </span>
            </button>
          </div>
        </div>
  
        <!-- errores de nivel formulario -->
        <div *ngIf="form.errors?.['atLeastOne']" class="text-red-200 text-sm -mt-3">
          Completá al menos uno: E-mail, Número de boleto o Código de devolución.
        </div>
  
      </form>
    </div>


    <div class="rounded-xl bg-[#1f46ea] text-white shadow-xl p-6 relative overflow-hidden mt-4" *ngIf="busqueda()">
    <h2 class="text-2xl font-bold">Resultados de la búsqueda</h2>
    <div>
      <div class="border rounded-lg p-4 mb-4 bg-white shadow-sm">
        <div *ngIf="loading()" class="flex justify-center items-center h-full">
          <mat-spinner></mat-spinner>
          <span>Buscando pasaje...</span>
        </div>

        <div *ngIf="ticket()?.data !== null">
          <div class="flex justify-between items-center mb-3">
            <div>
              <h4 class="text-sm font-semibold text-gray-700">Código: {{ ticket()?.data?.code }}</h4>
              <p class="text-xs text-gray-600 italic">{{ ticket()?.data?.ticket_status?.name | ticketStatus }}</p>
            </div>
            <!-- Acciones por ticket -->
            <div class="flex gap-2">
              <button mat-flat-button color="primary" matTooltip="Devolver" (click)="refundTicket(ticket())"
                [disabled]="refunding()"
                class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold px-12 py-3 rounded-xl disabled:cursor-not-allowed w-full">
                Devolver <mat-icon>undo</mat-icon>
                <span *ngIf="refunding()" class="flex items-center gap-2">
                  <mat-icon class="animate-spin">refresh</mat-icon>
                </span>
              </button>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 text-sm text-gray-700">
            <div>
              <span class="text-gray-500">Pasajero: </span>
              <strong>{{ ticket()?.data?.passenger?.name }} {{ ticket()?.data?.passenger?.last_name }}</strong>
              (DNI {{ ticket()?.data?.passenger?.document_number }})
            </div>
            <div><span class="text-gray-500">Asiento: </span> <strong>{{ ticket()?.data?.seat_number }}</strong></div>
            <div><span class="text-gray-500">Salida:</span> {{ ticket()?.data?.departure_datetime | date: 'dd/MM/yyyy HH:mm' }}</div>
            <div><span class="text-gray-500">Llegada:</span> {{ ticket()?.data?.arrival_datetime | date: 'dd/MM/yyyy HH:mm' }}</div>
            <div><span class="text-gray-500">Origen:</span> {{ ticket()?.data?.origin?.name || '-' }}</div>
            <div><span class="text-gray-500">Destino:</span> {{ ticket()?.data?.destination?.name || '-' }}</div>
          </div>
        </div>
        
        <div *ngIf="ticket()?.data === null && !loading()">
          <p class="text-gray-500">No se encontró ningún pasaje con los datos proporcionados.</p>
        </div>
      </div>
    </div>






  </div>
  